export default "__VITE_ASSET__DUscZ6LY__"